import {
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Select,
  VStack,
} from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'
import { STUDY_FILTER_MAX_WIDTH } from '../../../../constants/completion'

interface Props {
  includeAllRoles: boolean
  onChange: (value: boolean) => void
  selectedStudy: string | null
  onStudyChange: (study: string | null) => void
  studies: Record<string, string>
}

export default function CompletionFilters({
  includeAllRoles,
  onChange,
  selectedStudy,
  onStudyChange,
  studies,
}: Props) {
  // Sort studies alphabetically by name
  const sortedStudies = Object.entries(studies).sort(([, nameA], [, nameB]) =>
    nameA.localeCompare(nameB)
  )

  return (
    <VStack align='stretch' spacing={4}>
      <Checkbox
        isChecked={includeAllRoles}
        onChange={(e) => onChange(e.target.checked)}
      >
        Show all completions - including admins and researchers
      </Checkbox>

      <FormControl maxW={STUDY_FILTER_MAX_WIDTH}>
        <FormLabel>Filter by Study</FormLabel>
        <HStack>
          <Select
            value={selectedStudy || ''}
            onChange={(e) => onStudyChange(e.target.value || null)}
            placeholder='All studies'
          >
            {sortedStudies.map(([studyId, studyName]) => (
              <option key={studyId} value={studyName}>
                {studyName}
              </option>
            ))}
          </Select>
          <IconButton
            aria-label='Clear study filter'
            icon={<CloseIcon />}
            size='sm'
            onClick={() => onStudyChange(null)}
            isDisabled={!selectedStudy}
          />
        </HStack>
      </FormControl>
    </VStack>
  )
}
